export default "__VITE_ASSET__073ca15b__"